import { TreatmentPlanProductCategory } from "~/api/models/TreatmentPlan";
import PlanCategory from "~/components/organisms/Plan/PlanCategory";

const HairPlanCategory = () => {
  return <PlanCategory category={TreatmentPlanProductCategory.hair} />;
};

export default HairPlanCategory;
